import { useQuery } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useGetCategories() {
  const project = useCurrentProject();
  return useQuery({
    queryKey: [project, 'categories'],
    initialData: {
      categories: [],
    },
    queryFn: () => Api.categories.getCategories(project),
  });
}
